export const reportDataForecast = {
  data: {
    rpp: '/COROTA/ForecastReport',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/ForecastReport',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    rpp: '/COROTA/ForecastReport',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/ForecastReport',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

export const reportDataForecastReportTry = {
  data: {
    rpp: '/COROTA/ForecastReportTray',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/ForecastReportTray',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    rpp: '/COROTA/ForecastReportTray',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/ForecastReportTray',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

export const reportDataForecastReportPatientTry = {
  data: {
    rpp: '/COROTA/ForecastReportPatientTray',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/ForecastReportPatientTray',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    rpp: '/COROTA/ForecastReportPatientTray',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/ForecastReportPatientTray',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};
